module.exports = __webpack_public_path__ + "static/media/pcariMainToolBarLogo.cc5ff756.png";